import { RxWithTherapistsDto, RxLifespanDto } from "../../../api-client";
import { navigateWithProjection } from "../../../helpers/searchParams/navigateWithProjection";
import PatientsStore, { PATIENT_SUBTABS } from "../../../stores/Patients/patientsStore";

/**
 * Navigate to patient details page with Rx information using the new projection system
 * @param rxId - The ID of the prescription
 * @param patientId - The ID of the patient
 * @param patientsStore - The patients store instance for navigation
 */
export const navigateToPatientRx = (rxId: string, patientId: number, patientsStore: PatientsStore) => {
    const navigate = (path: string) => {
        window.open(path, '_blank');
    };

    navigateWithProjection(patientsStore, navigate as any, {
        ctor: patientsStore.constructor,
        route: '/patient',
        patch: {
            selectedPatientId: patientId as any,
            selectedRxId: rxId,
            selectedSubTabStr: PATIENT_SUBTABS.PRESCRIPTIONS,
        },
        forceUrlBuild: true, // Force URL building since we're opening in new tab
    });
};

/**
 * Generic handler for any Rx data type with the required properties
 * @param rxData - The Rx data (either RxWithTherapistsDto or RxLifespanDto)
 * @param patientsStore - The patients store instance for navigation
 */
export const handleRxNavigation = (rxData: RxWithTherapistsDto | RxLifespanDto, patientsStore: PatientsStore) => {
    navigateToPatientRx(rxData.rxId, rxData.patient.id, patientsStore);
};
